import { Box, Button, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { useState } from 'react';
import Toaster from 'src/Toaster/Toaster';
import { TOKEN_KEY, url } from 'src/Helpers/utils/Constant';
import MultipleAndSingleImgValidateWithPreview from 'src/common/FileValidation/MultipleAndSingleImgValidateWithPreview';
import { useForm } from 'react-hook-form';

export default function UpdateGallery({
  gallery,
  handleClose,
  setRefreshTrigger,
}) {
  const token = localStorage.getItem(TOKEN_KEY);
  const Toast = Toaster();

  // loading state
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,

    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: gallery?.title || '',
      gallery_images: {},
    },
  });

  // ------------------- SUBMIT -------------------
  const onSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    try {
      if (gallery?.title !== values?.title) {
        formData.append('title', values?.title);
      }

      Object.keys(values?.gallery_images || {})?.forEach((key) => {
        const fileList = values?.gallery_images[key];
        if (fileList) formData.append('files', fileList); // fileList already a File
      });

      const response = await axios.patch(
        `${url}/api/v1/admin/gallery/${gallery?.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response?.data?.success) {
        Toast.fire({ icon: 'success', title: 'Gallery Updated!' });
        setRefreshTrigger((prev) => prev + 1);
        handleClose();
      } else {
        Toast.fire({ icon: 'error', title: response?.data?.message });
      }
    } catch (err) {
      Toast.fire({
        icon: 'error',
        title: err.response?.data?.message || 'Update failed',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      <TextField
        label='Gallery Title'
        fullWidth
        {...register('title', { required: 'Title is required' })}
        error={Boolean(errors.title)}
        sx={{ mb: 3 }}
      />

      <MultipleAndSingleImgValidateWithPreview
        mt='0'
        fileLimitSize={50}
        register={register}
        clearErrors={clearErrors}
        setError={setError}
        errors={errors}
        label='Gallery Images'
        fieldName='gallery_images'
        hideCustomLabel
        mode='multiple'
        onlyImage
        imgSerUrl={[]}
      />

      <Button
        sx={{ mt: 3, minWidth: 150 }}
        variant='contained'
        disabled={loading}
        onClick={handleSubmit(onSubmit)}
      >
        Update Gallery
      </Button>
    </Box>
  );
}
